import { QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "react-redux";
import Router from "./router";
import store from "./store";
import { GlobalFindBar } from "./ui/components/global";
import "./ui/style/index.scss";
import { queryClient } from "./utils";

const App = () => (
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <GlobalFindBar />
      <Router />
    </QueryClientProvider>
  </Provider>
);

export default App;
